import './axios'
import '../lib/webpack-jquery-ui'
import '../lib/webpack-jquery-ui/css'
import 'bootstrap'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from './vue-i18n'
import 'vue-popperjs/dist/vue-popper.css'
import 'vue-search-select/dist/VueSearchSelect.css'
import '@sweetalert2/theme-bootstrap-4/bootstrap-4.scss'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas)
library.add(fab)
dom.watch()

import './decimalAdjust'
import './datepicker'
import './globalInitialization'

export { i18n }
